import { UNIT, USER } from "../_constants/actionConstants";
import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";

const add =
  (newUnitData, tabId = null) =>
  async (dispatch) => {
    dispatch({ type: UNIT.ADD });
    const apiEndpoint = BASE_URL + "/api/Units/Add";
    try {
      const res = await axios.post(apiEndpoint, newUnitData);
      dispatch({
        type: UNIT.ADD_FULFILLED,
        tabId,
        unitList: res.data,
      });
      return res.data;
    } catch (err) {
      const errorId = getUUID();
      const type = UNIT.ADD_REJECTED;
      const newError = { errorId, type, error: err.response.data };
      actionScripts.ADD_ERROR.run(newError);
    }
  };

const update =
  (unitData, tabId = null) =>
  async (dispatch) => {
    dispatch({ type: UNIT.EDIT });
    const apiEndpoint = BASE_URL + "/api/Units/Update";
    try {
      const res = await axios.post(apiEndpoint, unitData);
      if (res.data.message) {
        dispatch({ type: UNIT.EDIT_REJECTED });
        console.log(res.data.message);
      } else {
        dispatch({
          type: UNIT.EDIT_FULFILLED,
          tabId,
          unitList: res.data,
        });
      }
      return res.data;
    } catch (err) {
      const errorId = getUUID();
      const type = UNIT.EDIT_REJECTED;
      const newError = { errorId, type, error: err.response.data };
      actionScripts.ADD_ERROR.run(newError);
    }
  };

/**
 * Fetches a list of all units - used in Register User Modal
 * @param {number} dist - Null if none provided. 59 for DES/SC.
 * @returns {function(function())}
 */
const getAll =
  (dist = null, tabId = null) =>
  async (dispatch) => {
    dispatch({ type: UNIT.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/Units/GetAll";
    try {
      const res = await axios.get(apiEndpoint, { params: { dist } });
      dispatch({
        type: UNIT.FETCH_ALL_FULFILLED,
        unitList: res.data,
        tabId,
      });
      return res.data;
    } catch (err) {
      const errorId = getUUID();
      const type = UNIT.FETCH_ALL_REJECTED;
      const newError = { errorId, type, error: err.response.data };
      actionScripts.ADD_ERROR.run(newError);
    }
  };

const getDetails = (unitId) => async (dispatch) => {
  dispatch({ type: UNIT.FETCH_DETAILS });
  const apiEndpoint = BASE_URL + "/api/Units/GetDetails/?unitId=" + unitId;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: UNIT.FETCH_DETAILS_FULFILLED, unitId, unitDetails: res.data });
    return; // void return is wrapped in Promise
  } catch (err) {
    const errorId = getUUID();
    const type = UNIT.FETCH_DETAILS_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
  }
};

const unitActions = {
  add,
  getAll,
  getDetails,
  update,
};

export default unitActions;
